module.exports = __webpack_public_path__ + "img/outfield-picnic-pavilion-02.358bbe29.jpeg";